module.exports = __webpack_public_path__ + "img/ic_signature.cca043bd.svg";